/**
 * Destino post-login del parámetro `?next=` de `/auth`.
 *
 * Quién lo usa: las pantallas del plugin de Premiere (`/grabar-voz`,
 * `/generar-audio`, `/grabar-dialogo`) mandan a `/auth?next=/grabar-voz?...` cuando
 * no hay sesión y esperan volver ahí después de entrar.
 *
 * **Sólo rutas relativas** (`/algo`): un `next` absoluto (`//evil.com`,
 * `https://…`) sería un open redirect — se descarta y cae a `/`.
 *
 * Extraído de `Auth.tsx` al reemplazarlo por el onboarding nuevo
 * (ADR-2026-07-31-onboarding-nuevo-es-el-flujo-real): lo consumen la pantalla de
 * `/auth` y el formulario de auth, que antes navegaban siempre a `/`.
 */
export function getPostLoginDest(): string {
  try {
    const next = new URLSearchParams(window.location.search).get('next');
    if (next && next.startsWith('/') && !next.startsWith('//')) return next;
  } catch {
    /* URL rara: cae al default */
  }
  return '/';
}

export default getPostLoginDest;
